import React, { useState } from 'react'

import type { BerthCard } from '../../types'
import { UnassignedBookingCard } from '../UnassignedBookingCard'

import styles from './index.module.css'

type Props = {
  cards: BerthCard[]
  isLoading?: boolean
  onCardTap: (cardId: string) => void
}

export const UnassignedArea: React.FC<Props> = ({ cards, isLoading, onCardTap }) => {
  const [collapsed, setCollapsed] = useState(false)

  const hasCards = cards && cards.length > 0

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        バース未割り当て予約
        {hasCards && (
          <button
            className={`${styles.toggleButton} ${collapsed ? '' : styles.toggleButtonOpen}`}
            onClick={() => setCollapsed(!collapsed)}
            aria-label={collapsed ? '展開する' : '折りたたむ'}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
            </svg>
          </button>
        )}
      </div>
      {isLoading && !hasCards && (
        <div className={styles.loadingPlaceholder}>
          <div className={styles.loadingPlaceholderInner} />
        </div>
      )}
      {!isLoading && !hasCards && (
        <div className={styles.emptyMessage}>未割り当ての予約はありません</div>
      )}
      {hasCards && (
        <div className={`${styles.list} ${collapsed ? styles.listCollapsed : ''}`}>
          {cards.map((card) => (
            <UnassignedBookingCard key={card.id} card={card} onClick={() => onCardTap(card.id)} />
          ))}
        </div>
      )}
    </div>
  )
}
